import { createClient, createCache } from 'react-fetching-library';
import axios from 'axios';
import { requestHostInterceptor, axiosRequestHostInterceptor } from './requestInterceptors/requestHostInterceptor';
import { requestCheckTokenInterceptor, axiosRequestCheckTokenInterceptor } from './requestInterceptors/requestCheckTokenInterceptor';
import config from '../config';

const API_BASE_URL = config.apiUrl || 'http://localhost:4000';

const cache = createCache(
  (action) => {
    return action.method === 'GET';
  },
  (response) => {
    return new Date().getTime() - response.timestamp < 10000;
  },
);


export const oldClient = createClient({
  requestInterceptors: [requestCheckTokenInterceptor(API_BASE_URL), requestHostInterceptor(API_BASE_URL)],
  cacheProvider: cache,
});

const apiClient = axios.create({
  baseURL: API_BASE_URL,
  headers: {
    'response-type': 'json'
  }
});

//  config.headers.common.Authorization = `Bearer ${localStorage.getItem('jwt')}`;
apiClient.interceptors.request.use(axiosRequestHostInterceptor(API_BASE_URL), function (error) {
  console.log(error);
  return Promise.reject(error);
});
apiClient.interceptors.request.use(axiosRequestCheckTokenInterceptor(API_BASE_URL), function (error) {
  console.log(error);
  return Promise.reject(error);
});

export default apiClient;

function parseError(errorData) {
  let message;
  let type = 'general';
  let errors = [];

  const isArray = Array.isArray(errorData.errors);

  if (isArray) {
    errors = errorData.errors;
    type = errors[0].type;
    message = errors[0].error
  } else {
    message = errorData?.error;
  }

  if (message && typeof message === 'string') {
    return { message, type, errors };
  }


  return { message: 'GeneralError', type, errors };
}

export const fetcher = async (action, jwt) => {
  try {
    const { data } = await apiClient({ ...await action, jwt });

    if (data.success === false) {
      throw new ApiError({
        message: data.error,
        status: 400,
        type: 'general',
        statusText: 'BadRequest'
      })
    }

    return data;
  } catch (error) {
    if (error.isAxiosError) {
      const { status, statusText, data: errorData } = error.response ?? {};
      const { message, type, errors } = parseError(errorData);
      // const message = errorData?.error ?? errorData ?? 'GeneralError';

      throw new ApiError({
        message,
        status,
        type,
        statusText,
        errors
      })
    }

    if (error.name === 'ApiError') {
      throw new ApiError(error)
    }
    console.log({error})
    throw new Error(error?.message)

  }

};

class ApiError extends Error {
  constructor({ status, statusText, message, type, ...properties }) {
    super(message);
    this.name = 'ApiError';
    this.status = status;
    this.statusText = statusText;
    this.properties = properties;
    this.type = type;
  }
}